import React from "react";
import {UserAvatar} from "../components/user/UserAvatar"
import { Layout } from 'antd';

function Header({ onLogoClick }) {
    const { Header: AntHeader } = Layout;

    return (
        <AntHeader className='modern-header'>
            <div className="header-container" style={{ height: '100%', padding: '0 24px' }}>
                <div className="logo-home" onClick={onLogoClick}>WILD SEARCH</div>
                <div className="header-actions">
                    <UserAvatar />
                </div>
            </div>
        </AntHeader>
    )
}

export default Header

